import { useQuery } from "react-query";
import { get_performance_students } from "../../../faunadb/queries/performance";

export default function usePerformanceStudentList(client, id) {
    return useQuery(["performance", id, "student-list"], () => get_performance_students(client, id), { refetchOnWindowFocus: false })
}